<template>
  <div class="home">
<NavbarSesion/>
<bannerHero/>
<QueSomos/>
<TrainersHero/>
<PhotoSection/>
<FooterHero/>
  </div>
</template>

<script>
import NavbarSesion from '@/components/NavbarSesion.vue';
import bannerHero from '@/components/bannerHero.vue';
import QueSomos from '@/components/QueSomos.vue';
import TrainersHero from '@/components/TrainersHero.vue';
import PhotoSection from '@/components/PhotoSection.vue';
import FooterHero from '@/components/FooterHero.vue';
export default {
  name: 'HomeView',
  components: {
NavbarSesion,
bannerHero,
QueSomos,
TrainersHero,
PhotoSection,
FooterHero
  }
}
</script>
